import { render } from "./Artboard.vue?vue&type=template&id=8f9ece2a&scoped=true&ts=true"
import script from "./Artboard.vue?vue&type=script&lang=ts"
export * from "./Artboard.vue?vue&type=script&lang=ts"

import "./Artboard.vue?vue&type=style&index=0&id=8f9ece2a&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f9ece2a"]])

export default __exports__